import { Link, useLocation } from "react-router-dom";
import candidateStats from "../assets/candidateStats.png";
import countryStats from "../assets/countryStats.png";
import subtract from "../assets/Subtract.png";
import { PAGE_PATHS } from "../pages/page-paths";
import { useState } from "react";
import { getCookieObject } from "../utils/cookie";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";

type DecodedToken = {
  role: string;
  actorId: number;
  partnerId: BigInt;
  adminStateId?: number;
};
const Sidebar = ({ onNavigate }: { onNavigate?: () => void }) => {
  const location = useLocation();
  const [isCandidateOpen, setIsCandidateOpen] = useState(false);
  const [isPartnerOpen, setIsPartnerOpen] = useState(false);
  const [role, setRole] = useState<any>(null);

  useEffect(() => {
    const { access_token: accessToken } = getCookieObject();
    if (accessToken) {
      try {
        const decoded = jwtDecode<DecodedToken>(accessToken);
        console.log("decoded", decoded);
        setRole(decoded);
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);

  const toggleCandidateMenu = () => {
    setIsCandidateOpen(!isCandidateOpen);
  };
  const togglePartnerMenu = () => {
    setIsPartnerOpen(!isPartnerOpen);
  };

  const isPartnerAdmin = role?.role === "PARTNER_ADMIN";
  const isStateAdmin = role?.role === "STATE_ADMIN";
  return (
    <div className="w-64 bg-gradient-to-b from-[#0F41C1] via-[#0F41C1] to-[#170872] h-screen p-2 shadow-lg">
      <div className="flex justify-end md:hidden p-2"></div>
      <nav className="flex flex-col space-y-4 mt-20">
        {!isPartnerAdmin && !isStateAdmin && (
          <Link
            to={PAGE_PATHS.COUNTRY_STATS}
            className={`p-2 rounded-md flex gap-2 items-center ${location.pathname === PAGE_PATHS.DEFAULT
                ? "bg-[#001D67] text-white"
                : "hover:bg-[#001D67] text-white"
              }`}
            onClick={() => {
              onNavigate?.();
            }}
          >
            <img src={countryStats} alt="country-stats" />
            Country Statistics
          </Link>
        )}
        {!isPartnerAdmin && !isStateAdmin && (
          <Link
            to={PAGE_PATHS.VLE_STATS}
            className={`p-2 rounded-md flex gap-2 items-center ${location.pathname === PAGE_PATHS.VLE_STATS
                ? "bg-[#001D67] text-white"
                : "hover:bg-[#001D67] text-white"
              }`}
            onClick={() => {
              onNavigate?.();
            }}
          >
            <img src={subtract} alt="vle-stats" />
            VLE Report
          </Link>
        )}
        {!isPartnerAdmin && (
          <>
            {" "}
            <button
              onClick={toggleCandidateMenu}
              className={`p-2 w-full text-left rounded-md flex justify-between items-center ${location.pathname === PAGE_PATHS.CANDIDATE_REPORT
                  ? "bg-[#001D67] text-white"
                  : "hover:bg-[#001D67] text-white"
                }`}
            >
              <div className="flex gap-2 items-center">
                <img
                  className="h-5"
                  src={candidateStats}
                  alt="candidate-stats"
                />
                Candidate Statistics
              </div>
              <span>{isCandidateOpen ? "▲" : "▼"}</span>
            </button>
            {isCandidateOpen && (
              <div className="ml-8 flex flex-col gap-2">
                <Link
                  to={PAGE_PATHS.DRA_STATS}
                  className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.DRA_STATS
                      ? "bg-[#001D67] text-white"
                      : "hover:bg-[#001D67] text-white"
                    }`}
                  onClick={() => {
                    onNavigate?.();
                  }}
                >
                  DRA Candidates
                </Link>
                <Link
                  to={PAGE_PATHS.BCBF_STATS}
                  className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.BCBF_STATS
                      ? "bg-[#001D67] text-white"
                      : "hover:bg-[#001D67] text-white"
                    }`}
                  onClick={() => {
                    onNavigate?.();
                  }}
                >
                  BC Candidates
                </Link>
              </div>
            )}
          </>
        )}
        {!isStateAdmin && (
          <>
            <button
              onClick={togglePartnerMenu}
              className={`p-2 w-full text-left rounded-md flex justify-between items-center ${location.pathname === PAGE_PATHS.PARTNER
                  ? "bg-[#001D67] text-white"
                  : "hover:bg-[#001D67] text-white"
                }`}
            >
              <div className="flex gap-2 items-center">
                <img
                  className="h-5"
                  src={candidateStats}
                  alt="candidate-stats"
                />
                Partners
              </div>
              <span>{isPartnerOpen ? "▲" : "▼"}</span>
            </button>
            {isPartnerOpen && (
              <div className="ml-8 flex flex-col gap-2">
                {!isPartnerAdmin && (
                  <Link
                    to={PAGE_PATHS.ONBOARD_PARTNER}
                    className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.ONBOARD_PARTNER
                        ? "bg-[#001D67] text-white"
                        : "hover:bg-[#001D67] text-white"
                      }`}
                    onClick={() => {
                      onNavigate?.();
                    }}
                  >
                    Create/Update Partner
                  </Link>
                )}

                <Link
                  to={PAGE_PATHS.PARTNER_ONBOARD_USERS}
                  className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.PARTNER_ONBOARD_USERS
                      ? "bg-[#001D67] text-white"
                      : "hover:bg-[#001D67] text-white"
                    }`}
                  onClick={() => {
                    onNavigate?.();
                  }}
                >
                  Onboard Bulk Users
                </Link>
                <Link
                  to={PAGE_PATHS.PARTNER_CANDIDATES_LIST}
                  className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.PARTNER_CANDIDATES_LIST
                      ? "bg-[#001D67] text-white"
                      : "hover:bg-[#001D67] text-white"
                    }`}
                  onClick={() => {
                    onNavigate?.();
                  }}
                >
                  Candidates List
                </Link>
                {isPartnerAdmin && (
                  <Link
                    to={PAGE_PATHS.PARTNER_BATCH_ATTENDANCE}
                    className={`p-2 rounded-md ${location.pathname === PAGE_PATHS.PARTNER_BATCH_ATTENDANCE
                        ? "bg-[#001D67] text-white"
                        : "hover:bg-[#001D67] text-white"
                      }`}
                    onClick={() => {
                      onNavigate?.();
                    }}
                  >
                    Batch Attendance (Managed by Coordinator)
                  </Link>
                )}
              </div>
            )}
          </>
        )}
        {role?.role == "SUPER_ADMIN" && (
          <>
            <Link
              to={PAGE_PATHS.CREATE_ADMIN}
              className={`p-2 rounded-md flex gap-2 items-center ${location.pathname === PAGE_PATHS.CREATE_ADMIN
                  ? "bg-[#001D67] text-white"
                  : "hover:bg-[#001D67] text-white"
                }`}
              onClick={() => {
                onNavigate?.();
              }}
            >
              <img src={subtract} alt="vle-stats" />
              Create Admin/Partner
            </Link>
            <Link
              to={PAGE_PATHS.FREEZE_WINDOW}
              className={`p-2 rounded-md flex gap-2 items-center ${location.pathname === PAGE_PATHS.FREEZE_WINDOW
                  ? "bg-[#001D67] text-white"
                  : "hover:bg-[#001D67] text-white"
                }`}
              onClick={() => {
                onNavigate?.();
              }}
            >
              <img src={subtract} alt="vle-stats" />
              Freeze Re-payment Window
            </Link>
            <Link
              to={PAGE_PATHS.ADD_EXAM_DATE}
              className={`p-2 rounded-md flex gap-2 items-center ${location.pathname === PAGE_PATHS.ADD_EXAM_DATE
                  ? "bg-[#001D67] text-white"
                  : "hover:bg-[#001D67] text-white"
                }`}
              onClick={() => {
                onNavigate?.();
              }}
            >
              <img src={subtract} alt="vle-stats" />
              Add IIBF Exam Date
            </Link>
          </>
        )}
        {/* {role?.role == "SUPER_ADMIN" && (
          <Link
            to={PAGE_PATHS.CREATE_ADMIN}
            className={`p-2 rounded-md flex gap-2 items-center ${
              location.pathname === PAGE_PATHS.CREATE_ADMIN
                ? "bg-[#001D67] text-white"
                : "hover:bg-[#001D67] text-white"
            }`}
            onClick={() => {
              onNavigate?.();
            }}
          >
            <img src={subtract} alt="vle-stats" />
            Create Admin/Partner
          </Link>
        )} */}
      </nav>
    </div>
  );
};
export default Sidebar;
